import OutputMultiLineGraph from '../Visualisations/outputs/OutputMultiLineGraph'

// AI-CONTEXT: See docs/features/livereport-widgets-housevisits-personas.md
// Shared bar-chart visualisation for "Personas by status". Used by both
// `DashboardPersonaStatusCard` (dashboard) and the upcoming
// `PersonasStatusWidget` (live-report). Caller shapes the data; this
// component only renders.
//
// Interaction is delegated via `onItemClick`: the dashboard wires a deep-
// link to the personas overview filtered by status; the widget passes
// nothing → bars inert.

/**
 * @typedef {object} PersonasStatusDatum
 * @property {string} name - Visible bar label
 * @property {string} statusId - Status key forwarded to onItemClick
 * @property {{ total: number }} value - Bar value
 */

/**
 * @param {object} props
 * @param {Array<PersonasStatusDatum>} props.data
 * @param {string} props.color
 * @param {string|number} [props.height='100%']
 * @param {(item: PersonasStatusDatum) => void} [props.onItemClick]
 * @returns {JSX.Element}
 */
const PersonasStatusVisualization = ({
    data,
    color,
    height = '100%',
    onItemClick,
}) => {
    const bars = [{ Title: 'value', Color: color }]

    return (
        <OutputMultiLineGraph
            data={data}
            tableCategoryLabel="Status"
            tableValueLabel="Aantal"
            graphType="bar"
            outputs={bars}
            color={color}
            growth={{ average: 0, perOutput: {} }}
            height={height}
            displayLegend={false}
            onBarClick={onItemClick ? (payload) => onItemClick(payload) : undefined}
        />
    )
}

export default PersonasStatusVisualization
